import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "./backend-api";
import { ContainerStatus, K8sPod } from "../../../website/views/k8s-analyzer/k8s-analyzer-types";

interface K8sApiResponse {
  pods: K8sPod[];
  deploymentTypeMap: { [key: string]: string };
}

interface GetAllNodesResponse {
  nodes: any[]; // TODO: Define proper type for nodes
}

// Add a new interface for the pod logs request
interface PodLogsParams {
  podId: string;
  namespace: string;
  tail?: number; // Optional parameter to limit the number of lines
}

export const k8sApi = createApi({
  reducerPath: "k8sApi",
  baseQuery: apiBaseQuery,
  endpoints: (builder) => ({
    getK8SGatewayPodsAction: builder.mutation<K8sApiResponse, void>({
      query: () => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.getK8SGatewayPodsAction",
        },
      }),
    }),
    getK8SGatewayPodsWithRelatedSessionsAction: builder.mutation<K8sApiResponse, void>({
      query: () => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.getK8SGatewayPodsActionWithRelatedSessions",
        },
      }),
    }),
    deletePodByIdAction: builder.mutation<K8sApiResponse, string>({
      query: (podId) => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.deletePodByIdAction",
          podId: podId,
        },
      }),
    }),
    getAllNodesByDeploymentArrayAction: builder.mutation<GetAllNodesResponse, string[]>({
      query: (deploymentArray) => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.getAllNodesByDeploymentArrayAction",
          deploymentArray: deploymentArray,
        },
      }),
    }),
    sendSIGTERMtoPodAction: builder.mutation<K8sApiResponse, string>({
      query: (podId) => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.sendSIGTERMtoPodAction",
          podId: podId,
        },
      }),
    }),
    getPodLogsAction: builder.mutation<{ logs: string }, PodLogsParams>({
      query: (params) => ({
        url: "actions",
        method: "POST",
        body: {
          cmd: "k8s-interface.getPodLogsAction",
          podId: params.podId,
          namespace: params.namespace,
          tail: params.tail || 500, // Default to 500 lines
        },
      }),
    }),
  }),
});

export const {
  useGetK8SGatewayPodsActionMutation,
  useGetK8SGatewayPodsWithRelatedSessionsActionMutation,
  useDeletePodByIdActionMutation,
  useGetAllNodesByDeploymentArrayActionMutation,  
  useSendSIGTERMtoPodActionMutation,
  useGetPodLogsActionMutation,
} = k8sApi;

export const {
  getK8SGatewayPodsAction,
  getK8SGatewayPodsWithRelatedSessionsAction,
  deletePodByIdAction,
  getAllNodesByDeploymentArrayAction,
  sendSIGTERMtoPodAction,
  getPodLogsAction,
} = k8sApi.endpoints;

export const middleware = k8sApi.middleware;
export default k8sApi.reducer; 